export default function () {
  const widgetName = 'cardWidgetFooterLogoSlogan';
  const widgetOpts = cardWidgetFooterLogoSloganOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function () {
      $(`#${widgetName}`).find('.buttonwrap').remove();
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
